// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Al1m3lRiclUGsf8IwR55{align-items:center;display:flex}.wjrclQb_uA00Ozz_UkSS .irSl4EVX3LQtXRvO76UN{margin-left:4px}.wjrclQb_uA00Ozz_UkSS .AF0JYFZ6MYUEri8ybffg{margin-left:6px}.irSl4EVX3LQtXRvO76UN{color:var(--content-primary-tertiary)}.AF0JYFZ6MYUEri8ybffg{color:var(--content-primary-primary);max-width:150px;margin-left:8px}.usq_mGCtLxkkITOiTrYt{color:var(--content-neutral-primary);margin-left:8px}.ESWk6tRd62g4SY_eu1Me{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.iDdVjDtpYykTuamq294N{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Al1m3lRiclUGsf8IwR55`,
	"wrap--checkbox": `wjrclQb_uA00Ozz_UkSS`,
	"wrapCheckbox": `wjrclQb_uA00Ozz_UkSS`,
	"icon": `irSl4EVX3LQtXRvO76UN`,
	"title": `AF0JYFZ6MYUEri8ybffg`,
	"count": `usq_mGCtLxkkITOiTrYt`,
	"highlighter": `ESWk6tRd62g4SY_eu1Me`,
	"highlighter--label": `iDdVjDtpYykTuamq294N`,
	"highlighterLabel": `iDdVjDtpYykTuamq294N`
};
export default ___CSS_LOADER_EXPORT___;
